import { useDisplayVariant } from 'modules/productDetail'
import * as React from 'react'
import config from 'config'

export default function useAttributes() {
  const variant = useDisplayVariant()
  return React.useMemo(() => {
    const labels: {
      label: string
      value?: string | number
    }[] = []
    const icons: { label: string; icon: string }[] = []

    Object.keys(variant.data.attributes).forEach((attributeKey) => {
      const values: string[] = []

      // skip attributes "WARRANTY_REPURCHASE", "CERTIFIED" and is_pdp_attribute === false
      if (
        attributeKey === 'WARRANTY_REPURCHASE' ||
        (attributeKey === 'CERTIFIED' &&
          variant.data.attributes[attributeKey].values[0].icon)
      )
        return
      if (!variant.data.attributes[attributeKey].is_pdp_attribute) return

      /** fill values and icons variables */
      variant.data.attributes[attributeKey].values.forEach((val) => {
        const keys = Object.keys(val)

        // get all attributes with icons
        if (keys.includes('icon')) {
          icons.push({
            label: val.value?.toString() || '',
            icon: config.modules.cloudinary.endpoint + val.icon
          })
        }

        // get all other attributes with no documents (e.g. energyLabel)
        else if (!keys.includes('document')) {
          if (keys.includes('unit') && keys.includes('value')) {
            const sorted_val = `${val.value} ${val.unit}`
            values.push(sorted_val)
          } else {
            values.push(val.value?.toString() || '')
          }
        }
      })
      if (values.length > 0)
        labels.push({
          label: variant.data.attributes[attributeKey].label,
          value: values.join(', ')
        })
    })

    return {
      icons: icons,
      labels: labels,
      manufacturerName: variant.data.attributes.MANUFACTURER_NAME
        ? variant.data.attributes.MANUFACTURER_NAME.values[0].value
        : null,
      manufacturerAddress: variant.data.attributes.MANUFACTURER_ADDRESS
        ? variant.data.attributes.MANUFACTURER_ADDRESS.values[0].value
        : null,
      manufacturerMail: variant.data.attributes.MANUFACTURER_MAIL
        ? variant.data.attributes.MANUFACTURER_MAIL.values[0].value
        : null
    }
  }, [variant.data.attributes])
}
